import { render } from "./DisclaimerPopup.vue?vue&type=template&id=f08ef4ec"
import script from "./DisclaimerPopup.vue?vue&type=script&lang=js"
export * from "./DisclaimerPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__